
import {
  Component,
  AfterContentInit,
  OnDestroy,
  ElementRef
} from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { UIService } from '../../ui.service';
import {
  HelpService,
  HelpType
} from '../../components/common/help/help.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { Configuration } from '../../conf/app.constants';
import { Router } from '@angular/router';
import { PaginationDTO } from '../../api/PaginationModel';
import { CriteriaDefEditionComponent } from './criteria.edition.component';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { CriteriaDefDTO } from '../../api/plyca-dtos-v2';
import { BaseComponent } from '../../components/common/baseComponent/base.component';


@Component({
  selector: 'criteriaDefListPanel',
  templateUrl: 'criteriaDefListPanel.template.html'
})
export class criteriaDefListPanelComponent extends BaseComponent
  implements AfterContentInit, OnDestroy {
  loaded = false;
  criteriaDefList: CriteriaDefDTO[] = [];

  constructor(
    public plycaService: PlycaDataService,
    public helpService: HelpService,
    public uiService: UIService,
    private headerActionsService: HeaderActionsService,
    private elem: ElementRef,
    protected configuration: Configuration,
    public dialogService: DialogService,
    public translate: TranslateService,
    private router: Router
  ) {
    super();
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.CRITERIADEF));
  }

  ngAfterContentInit(): void {
    this.headerActionsService.clearActions();

    this.headerActionsService.setTaskDescription(
      this.elem,
      'ControlPanel.criteriaDefList.title',
      'fab fa-readme',
      this.isLoaded.bind(this)
    );

    this.subscribe(this.headerActionsService
      .addAction(
        'General.add',
        'fas fa-plus',
        'btn-primary',
        true
      )

      ,
      () => {
        this.editCriteriaDef();
      }
    );

    this.subscribe(this.headerActionsService
      .addAction('General.reload', 'fas fa-sync-alt', 'btn-secondary', true)

      ,
      () => {
        this.loadCriteriaDefList();
      }
    );




    this.headerActionsService.addDivider();
    this.subscribe(
      this.headerActionsService
        .addAction(
          'General.back',
          'fas fa-chevron-left',
          'btn-outline-secondary',
          true
        )
      ,

      () => {
        this.uiService.routeBack();
      }


    );





    this.loadCriteriaDefList();
  }

  ngOnDestroy(): void { }

  public isLoaded(): boolean {
    return this.loaded;
  }

  loadCriteriaDefList() {
    this.loaded = false;
    this.subscribe(
      this.plycaService
        .query<CriteriaDefDTO>(this.configuration.CRITERIADEF_SERVICE_URL)

      ,
      (result: PaginationDTO<CriteriaDefDTO>) => {
        if (result && result.content) {
          this.criteriaDefList = result.content;
          if (!this.criteriaDefList) {
            this.criteriaDefList = [];
          }
        }
        this.loaded = true;
      }

    );


  }


  editCriteriaDef(criteriaDef?: CriteriaDefDTO) {
    let config: DynamicDialogConfig = {
      header: this.translate.instant('ControlPanel.criteriaDefList.title'),
      width: '70%',
      style: { overflow: 'scroll' },
      styleClass: 'formEdition'
    };
    if (criteriaDef) {
      config['id'] = criteriaDef.identifier;
    }

    const ref = this.dialogService.open(
      CriteriaDefEditionComponent,
      config
    );

    this.subscribe(

      ref.onClose
      ,
      result => {
        this.loadCriteriaDefList();
      }

    )

  }
}
